import { useEffect, useLayoutEffect, useRef } from 'react';

const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect;

/** Grows the textarea with its content; CSS `max-height` caps it and scrolls beyond that. */
export const useTextareaAutoResize = (value: unknown) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useIsomorphicLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const resize = () => {
      textarea.style.height = '0px';
      textarea.style.height = `${String(textarea.scrollHeight)}px`;
    };

    resize();
    textarea.addEventListener('input', resize);
    let width = textarea.getBoundingClientRect().width;
    const observer =
      typeof ResizeObserver === 'undefined'
        ? undefined
        : new ResizeObserver(() => {
            const nextWidth = textarea.getBoundingClientRect().width;
            if (nextWidth !== width) {
              width = nextWidth;
              resize();
            }
          });
    observer?.observe(textarea);

    return () => {
      textarea.removeEventListener('input', resize);
      observer?.disconnect();
    };
  }, [value]);

  return textareaRef;
};
